import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/components/ui/alert-dialog'
import { Playbook } from '@/types/playbook'
import { SubmitHandler, useForm } from 'react-hook-form'

export type FormValues = {
  confirmed: boolean
}

type PlaybookDeleteModalProps = {
  playbook?: Pick<Playbook, 'title'> | null
  onSubmit: SubmitHandler<FormValues>
  isOpen: boolean
}

export function PlaybookDeleteModal({
  playbook,
  onSubmit,
  isOpen,
}: PlaybookDeleteModalProps) {
  const form = useForm<FormValues>({
    defaultValues: {
      confirmed: false,
    },
  })

  const {
    setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = form

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete playbook?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. This will permanently delete
              {playbook?.title ? ` "${playbook.title}"` : ' this playbook'}.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              disabled={isSubmitting}
              type="submit"
              onClick={() => setValue('confirmed', false)}
            >
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              disabled={isSubmitting}
              type="submit"
              onClick={() => setValue('confirmed', true)}
            >
              {isSubmitting ? 'Deleting…' : 'Delete'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </form>
      </AlertDialogContent>
    </AlertDialog>
  )
}
